import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Bot } from 'lucide-react';

const LINE_OA_URL = 'https://lin.ee/4WzcOt7';

const LineIcon = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386c-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63h2.386c.346 0 .627.285.627.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .27-.174.51-.432.596-.064.021-.133.031-.199.031-.211 0-.391-.09-.51-.25l-2.443-3.317v2.94c0 .344-.279.629-.631.629-.346 0-.626-.285-.626-.629V8.108c0-.27.173-.51.43-.595.06-.023.136-.033.194-.033.195 0 .375.104.495.254l2.462 3.33V8.108c0-.345.282-.63.63-.63.345 0 .63.285.63.63v4.771zm-5.741 0c0 .344-.282.629-.631.629-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63.346 0 .628.285.628.63v4.771zm-2.466.629H4.917c-.345 0-.63-.285-.63-.629V8.108c0-.345.285-.63.63-.63.348 0 .63.285.63.63v4.141h1.756c.348 0 .629.283.629.63 0 .344-.282.629-.629.629M24 10.314C24 4.943 18.615.572 12 .572S0 4.943 0 10.314c0 4.811 4.27 8.842 10.035 9.608.391.082.923.258 1.058.59.12.301.079.766.038 1.08l-.164 1.02c-.045.301-.24 1.186 1.049.645 1.291-.539 6.916-4.078 9.436-6.975C23.176 14.393 24 12.458 24 10.314" />
  </svg>
);

interface FloatingSupportProps {
  showAi?: boolean;
}

const FloatingSupport = ({ showAi = false }: FloatingSupportProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8, y: 12 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.2, duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
      className="fixed right-4 lg:right-6 bottom-20 lg:bottom-6 z-50 flex flex-col gap-3"
    >
      <a
        href={LINE_OA_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="加入 LINE 好友"
        className="group relative flex items-center justify-center w-12 h-12 lg:w-14 lg:h-14 rounded-full shadow-soft hover:shadow-elevated transition-all duration-300 hover:scale-110"
        style={{ backgroundColor: '#06C755', color: '#FFFFFF' }}
      >
        <LineIcon className="w-7 h-7 lg:w-8 lg:h-8" />
        <span className="pointer-events-none absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap px-2.5 py-1 rounded-md bg-foreground/90 text-background text-xs opacity-0 group-hover:opacity-100 transition-opacity hidden lg:block">
          加入 LINE 好友
        </span>
      </a>

      {showAi && (
        <Link
          to="/ai-support"
          aria-label="智能客服"
          className="group relative flex items-center justify-center w-12 h-12 lg:w-14 lg:h-14 rounded-full shadow-soft hover:shadow-elevated transition-all duration-300 hover:scale-110 bg-primary text-primary-foreground"
        >
          <Bot className="w-6 h-6 lg:w-7 lg:h-7" strokeWidth={1.75} />
          <span className="pointer-events-none absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap px-2.5 py-1 rounded-md bg-foreground/90 text-background text-xs opacity-0 group-hover:opacity-100 transition-opacity hidden lg:block">
            智能客服
          </span>
        </Link>
      )}
    </motion.div>
  );
};

export default FloatingSupport;
